import type { VaultData } from '@onefootprint/request-types';
import compact from 'lodash/compact';

export const arrayToCommaSeparated = (value: unknown) => {
  return Array.isArray(value) ? value.join(', ') : '';
};

export const commaSeparatedToArray = (value: string) => {
  return compact(value.split(',').map(s => s.trim()));
};

export const convertCommaSeparatedFieldToArray = (vaultData: VaultData, fieldName: keyof VaultData) => {
  const value = vaultData[fieldName];

  if (!value || typeof value !== 'string') {
    return;
  }
  const array = commaSeparatedToArray(value);

  if (array.length > 0) {
    (vaultData as Record<string, unknown>)[fieldName] = array;
  } else {
    delete vaultData[fieldName];
  }
};
